import {
  DataTableColumnSwitchProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';

interface IgetPlanningDataTableObjectProps {
  store: MeetingRepository;
  isDisabled: boolean;
}

export const getPlanningDataTableObject = ({ store, isDisabled }: IgetPlanningDataTableObjectProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.planning.table.ref',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const typeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.planning.table.type',
    accessorKey: 'type',
    variant: DataTableColumnVariant.TEXT,
  };

  const acColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'meeting.planning.table.ac',
    accessorKey: 'ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const checkPlanningColumn: DynamicDataTableColumn<DataTableColumnSwitchProps> = {
    label: 'meeting.planning.table.check',
    accessorKey: 'checkPlanning',
    variant: DataTableColumnVariant.SWITCH,
    props: {
      disabled: isDisabled,
      onChange: isDisabled
        ? undefined
        : (event: any, value: any, row: any) => {
            if (row.type === 'PPM') {
              const current = store.getNested<any[]>('dto', 'reunionPpms') || [];

              if (event.checked) {
                const exists = current.some(r => r.id === row.id);
                if (!exists) {
                  store.setNested('dto', 'reunionPpms', [
                    ...current,
                    {
                      id: row.id,
                      version: row.version,
                      processInstanceId: row.processInstanceId,
                      taskId: row.taskId,
                    },
                  ]);
                }
              } else {
                store.setNested(
                  'dto',
                  'reunionPpms',
                  current.filter(r => r.id !== row.id)
                );
              }
              store.clearError('reunionPpms');
            } else if (row.type === 'DAC') {
              const current = store.getNested<any[]>('dto', 'reunionDacs') || [];

              if (event.checked) {
                const exists = current.some(r => r.dacId === row.id);
                if (!exists) {
                  store.setNested('dto', 'reunionDacs', [
                    ...current,
                    {
                      dacId: row.id,
                      dacVer: row.version,
                      processInstanceId: row.processInstanceId,
                      taskId: row.taskId,
                    },
                  ]);
                }
              } else {
                store.setNested(
                  'dto',
                  'reunionDacs',
                  current.filter(r => r.dacId !== row.id)
                );
              }
              store.clearError('reunionDacs');
            } else if (row.type === 'ADDITIF') {
              const current = store.getNested<any[]>('dto', 'reunionDemandes') || [];
              if (event.checked) {
                const exists = current.some(r => r.id === row.id);
                if (!exists) {
                  store.setNested('dto', 'reunionDemandes', [
                    ...current,
                    {
                      id: row.id,
                      version: row.version,
                      processInstanceId: row.processInstanceId,
                      taskId: row.taskId,
                    },
                  ]);
                }
              } else {
                store.setNested(
                  'dto',
                  'reunionDemandes',
                  current.filter(r => r.id !== row.id)
                );
              }
              store.clearError('reunionDemandes');
            } else if (row.type === 'REPORT') {
              const current = store.getNested<any[]>('dto', 'reunionReports') || [];
              if (event.checked) {
                const exists = current.some(r => r.id === row.id);
                if (!exists) {
                  store.setNested('dto', 'reunionReports', [
                    ...current,
                    {
                      id: row.id,
                      version: row.version,
                      processInstanceId: row.processInstanceId,
                      taskId: row.taskId,
                    },
                  ]);
                }
              } else {
                store.setNested(
                  'dto',
                  'reunionReports',
                  current.filter(r => r.id !== row.id)
                );
              }
              store.clearError('reunionReports');
            }
          },
    },
  };

  return {
    singular: 'meeting.planning.singular',
    plural: 'meeting.planning.plural',
    columns: [refColumn, typeColumn, acColumn, checkPlanningColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    disablePagination: false,
    searchableFields: ['ref', 'type', 'ac.nom'],
  };
};
